import {
  SOURCE,
  ends
} from "./constant"

export function imgCompress(dom, callback, errorCallback) {
  if (!dom)
    return
  const MAX_SIZE = 8 * 1024 * 1024
  dom.onchange = function () {
    const rate = 1;
    let file = dom.files[0];
    if (file.size > MAX_SIZE) {
      errorCallback && errorCallback();
      return
    }
    let canvas = document.createElement('canvas');
    let ctx = canvas.getContext('2d');
    let url = _getImgUrl(file);
    let img = new Image;
    img.src = url;
    img.onload = function () {
      let imgWidth = img.width;
      let imgHeight = img.height;
      let imgRate = (imgWidth < imgHeight ?
        imgWidth / imgHeight :
        imgHeight / imgWidth) / rate;
      canvas.width = imgWidth * imgRate;
      canvas.height = imgHeight * imgRate;
      ctx.drawImage(img, 0, 0, imgWidth, imgHeight, 0, 0, imgWidth *
        imgRate, imgHeight * imgRate);
      let imgUrl = canvas.toDataURL('image/jpeg');
      canvas = null;
      callback && callback.call(this, {
        image: imgUrl
      })
    }
  }
}



function _getImgUrl(file) {
  let url = null;
  if (window.createObjectURL != undefined) { // basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) { // mozilla(firefox)
    url = window
      .URL
      .createObjectURL(file);
  } else if (window.webkitURL != undefined) { // web_kit or chrome
    url = window
      .webkitURL
      .createObjectURL(file);
  }
  return url;
}


function formatCPFBr(str, clear) {
  let tempVal = str.slice(0, 14).replace(/\D/g, "");
  if (clear) {
    return tempVal
  }
  let l = tempVal.length;
  //076.571.654-21
  if (l === 3 || l === 6 || l === 9) return str;
  let result = "";
  for (let i = 0; i < l; i++) {
    result += tempVal[i];
    if (i === 2 || i === 5) {
      result += "."
    } else if (i === 8) {
      result += "-"
    }
  }
  return result
}

function formatCNPJBr(str, clear) {

  let tempVal = str.slice(0, 18).replace(/\D/g, "");
  if (clear) {
    return tempVal
  }
  let l = tempVal.length;
  //77.188.118/0001-10
  if (l === 2 || l === 5 || l === 8 || l === 12) return str;
  let result = "";
  for (let i = 0; i < l; i++) {
    result += tempVal[i];
    if (i === 1 || i === 4) {
      result += "."
    } else if (i === 7) {
      result += "/"
    } else if (i === 11) {
      result += "-"
    }
  }
  return result
}

function formatAccent(str) {
  const accents =
    "ÀÁÂÃÄÅĄàáâãäåąßÒÓÔÕÕÖØŐòóôőõöøĎďDŽdžÈÉÊËĘèéêëęðÇçČčĆćÐÌÍÎÏìíîïÙÚÛÜŰùűúûüĽĹŁľĺłÑŇŃňñńŔŕŠŚšśŤťŸÝÿýŽŻŹžżź";
  const unAccents =
    "AAAAAAAaaaaaaasOOOOOOOOoooooooDdDZdzEEEEEeeeeeeCcCcCcDIIIIiiiiUUUUUuuuuuLLLlllNNNnnnRrSSssTtYYyyZZZzzz";
  str = str.split("");
  const strLen = str.length;
  let i, x;
  for (i = 0; i < strLen; i++) {
    if ((x = accents.indexOf(str[i])) != -1) {
      str[i] = unAccents[x];
    }
  }
  return str.join("");
}

function formatCURPMx(str) {
  return formatAccent(str).toUpperCase()
}

function formatCarPlateBr(val, clear) {
  if (clear) {
    return val.replace(/[\W_]/g, "")
  }
  const carPlateInputReg = /^([A-Z]{3})([A-Z0-9]{1})$/;
  return val.toUpperCase().replace(carPlateInputReg, ($1, $2, $3) => $2 + "-" +
    $3);
}

//更新form状态，需要与父级通信时，触发此更新，大多数是通知父级新值已经可用
function emitFormUpdate(context, idx, ...a) {
  context.$emit("form-update", idx, ...a);
}


let up = new URLSearchParams(location.search);

function getEnd() {
  let up = new URLSearchParams(location.search);
  const bundle_id = up.get('bundle_id') || "";
  let end = "WebEnd" // 手机浏览器
  if (bundle_id.indexOf(SOURCE.fleet) > -1) {
    end = "FleetEnd" // 手机Fleet
  } else if (bundle_id.indexOf(SOURCE.global) > -1) {
    end = "DriverEnd" // 手机司机端
  } else if (bundle_id.indexOf(SOURCE.br_99) > -1) {
    end = "DriverEnd" // 手机司机端
  } else if (bundle_id.indexOf (SOURCE.globalIos) > -1) {
    end = 'DriverEnd'; // 手机司机端(ios)
  } else if (bundle_id.indexOf (SOURCE.minibus_new) > -1 || bundle_id.indexOf (SOURCE.minibus_old) > -1) {
    end = 'DriverEnd'; // 小巴司机端
  } else if ((ends.isIOS && (up.get('datatype') == 101)) ||
    (ends.isAndroid && (up.get('datatype') == 1))) {
    //乘客端
    end = "PassengerEnd"
  } else if (ends.isPC) {
    //官方网站
    end = "PCEnd"
  }
  return end
}

export {
  formatCPFBr,
  formatCNPJBr,
  formatCarPlateBr,
  formatAccent,
  formatCURPMx,
  emitFormUpdate,
  getEnd
}
